// extracted by mini-css-extract-plugin
module.exports = {"component":"show-list_component_13Kmd","title":"show-list_title_3IocK","item-wrapper":"show-list_item-wrapper_1u060","item-wrapper--rows":"show-list_item-wrapper--rows_1QFeM"};